import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { getHosts, deleteHost } from '../../services/hostService';

const HostList = () => {
  const [hosts, setHosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHosts = async () => {
      try {
        const data = await getHosts();
        setHosts(data);
      } catch (error) {
        console.error('Error fetching hosts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchHosts();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this host?')) {
      try {
        await deleteHost(id);
        setHosts(hosts.filter(host => host._id !== id));
      } catch (error) {
        console.error('Error deleting host:', error);
      }
    }
  };

  const columns = [
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'description', headerName: 'Description', width: 300 },
    { field: 'mongoUri', headerName: 'Mongo URI', width: 300 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 200,
      renderCell: (params) => (
        <Box>
          <Button
            component={Link}
            to={`/hosts/edit/${params.row._id}`}
            size="small"
            variant="outlined"
            sx={{ mr: 1 }}
          >
            Edit
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="error"
            onClick={() => handleDelete(params.row._id)}
          >
            Delete
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h5">Hosts</Typography>
        <Button component={Link} to="/hosts/new" variant="contained">
          Add Host
        </Button>
      </Box>
      <DataGrid
        rows={hosts}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        getRowId={(row) => row._id}
        loading={loading}
      />
    </Box>
  );
};

export default HostList;